module.exports = __webpack_public_path__ + "static/img/Bridge.c16e778.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/card/Bridge.jpg
// module id = TVNo
// module chunks = 1